import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Strategy } from 'client/voladeum/strategies/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: Strategy[] = EMPTY_ARRAY;

export const strategiesSlice = createSlice({
  name: SLICE.STRATEGIES,
  initialState,
  reducers: {
    setStrategies: (_state, action: PayloadAction<Strategy[]>) => {
      return action.payload;
    },
    clearStrategies: () => {
      return initialState;
    },
  },
});

export const { setStrategies, clearStrategies } = strategiesSlice.actions;

export default strategiesSlice.reducer;
